
// import axios from "axios";

// export function generateDynamicLink(storeSlug: string): string {
//   let searchPrams = new URLSearchParams({
//     link: `https://buy.modulusseventeen.com/store/${storeSlug}`,
//     apn: 'com.modulusbuy.android',
//     amv: '27',
//     afl: `https://buy.modulusseventeen.com/store/${storeSlug}`,
//     ofl: `https://buy.modulusseventeen.com/store/${storeSlug}`,
//     ibi: `com.modulusbuy.ios`,
//     ifl: `https://buy.modulusseventeen.com/store/${storeSlug}`,
//     imv: '27',
//     utm_campaign: 'banner',
//   });
//   return 'https://modulusbuymobile.page.link/?' + searchPrams;
// }

// export async function firebaseDynamicShortLink(storeSlug: string): Promise<{ shortLink: string }> {
//   try {
//     const response = await axios.post('https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyBBlNszDeAJkUlvOtVSoIj-PGlbgUuVpHY',
//       {
//         "dynamicLinkInfo": {
//           domainUriPrefix: 'https://modulusbuymobile.page.link',
//           link: `https://buy.modulusseventeen.com/store/${storeSlug}`,
//           "androidInfo": {
//             "androidPackageName": 'com.modulusbuy.android',
//             "androidFallbackLink": `https://buy.modulusseventeen.com/store/${storeSlug}`,
//             "androidMinPackageVersionCode": '55'
//           },
//           "iosInfo": {
//             "iosBundleId": `com.modulusbuy.ios`,
//             "iosFallbackLink": `https://buy.modulusseventeen.com/store/${storeSlug}`,
//             // "iosCustomScheme": string,
//             "iosIpadFallbackLink": `https://buy.modulusseventeen.com/store/${storeSlug}`,
//           },
//           "navigationInfo": {
//             "enableForcedRedirect": true,
//           },
//         },
//         "suffix": {
//           "option": "SHORT" // "UNGUESSABLE"
//         }
//       }
//       , {
//         headers: {
//           "Content-Type": "application/json",
//         }
//       })
//     return response.data;
//   } catch (error) {
//     return { shortLink: "" }
//   }
// }

import {toWords} from "number-to-words"

export const debounce = (callback: (...args: any[]) => void, delay: number) => {
  let timeoutId: NodeJS.Timeout | null = null;
  
  return (...args: any[]) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      callback(...args); // ✅ Pass arguments correctly
    }, delay);
  };
};


export const currencyFormatter = (amount: number | null | undefined): string => {
  if (amount == null) return "₹0";
  
  const isNegative = amount < 0;
  const formatted = Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
  }).format(Math.abs(amount));

  return isNegative ? `-${formatted}` : formatted;
};

export const formatCurrencyWithoutTrailingZero = (amount: number | null | undefined): string => {
  const formatted = currencyFormatter(amount || 0);
  return formatted.replace(/\.00$/, '');
};

export const formatNumberWithoutSymbol = (amount: number | null | undefined): string => {
  if (amount == null) return "0";
  
  const isNegative = amount < 0;
  const formatted = Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Math.abs(amount));

  // Remove trailing .00 if present
  const withoutTrailingZero = formatted.replace(/\.00$/, '');
  return isNegative ? `-${withoutTrailingZero}` : withoutTrailingZero;
};

export const convertAmountToWords = (amount: number) => {
  const [rupeesPart, paisePart] = amount.toFixed(2).split(".");
  const rupeesWords = toWords(parseInt(rupeesPart)).replace(/\b\w/g, c => c.toUpperCase());

  let finalWords = rupeesWords;
  if (parseInt(paisePart) > 0) {
    const paiseWords = toWords(parseInt(paisePart)).replace(/\b\w/g, c => c.toUpperCase());
    finalWords += ` and ${paiseWords} Paise`;
  }
  return finalWords;
};

export function getUpdatedValues(original:any, updated:any) {
  const diff = {};

  // Handle cases where original or updated are not objects or are null
  if (
    typeof original !== 'object' ||
    original === null ||
    typeof updated !== 'object' ||
    updated === null
  ) {
    if (original !== updated) {
      return updated; // Return the updated value if types or values differ
    }
    return undefined; // No difference
  }

  // Check for removed properties
  for (const key in original) {
    if (!(key in updated)) {
      diff[key] = undefined; // Indicate removal
    }
  }

  // Check for updated or added properties
  for (const key in updated) {
    if (key in original) {
      // Deeply compare if both are objects or arrays
      if (
        typeof original[key] === 'object' &&
        original[key] !== null &&
        typeof updated[key] === 'object' &&
        updated[key] !== null
      ) {
        if (Array.isArray(original[key]) && Array.isArray(updated[key])) {
          // Compare arrays: check for length changes and element differences
          if (original[key].length !== updated[key].length) {
            diff[key] = updated[key];
          } else {
            const arrayDiff = getUpdatedValues(original[key], updated[key]);
            if (Object.keys(arrayDiff).length > 0) {
              diff[key] = updated[key]; // Return the whole updated array if elements changed
            }
          }
        } else {
          // Compare nested objects
          const nestedDiff = getUpdatedValues(original[key], updated[key]);
          if (Object.keys(nestedDiff).length > 0) {
            diff[key] = nestedDiff;
          }
        }
      } else if (original[key] !== updated[key]) {
        // Primitive value changed
        diff[key] = updated[key];
      }
    } else {
      // New property added
      diff[key] = updated[key];
    }
  }

  return diff;
}